const stages = [
  {
    step: "第一幕",
    name: "入门扎根期",
    desc: "主角拜入宗门，熟悉宗门的运转规则与同门日常，建立最初的羁绊与身份。",
    icon: "ri-home-heart-line",
  },
  {
    step: "第二幕",
    name: "历练成长期",
    desc: "下山历练中一次次突破自我，实力与心性同步成长，也逐渐触碰宗门深藏的秘密。",
    icon: "ri-compass-3-line",
  },
  {
    step: "第三幕",
    name: "内乱抉择期",
    desc: "宗门内部矛盾激化，主角被迫在师门情谊与心中道义间做出选择，故事由此推向高潮。",
    icon: "ri-sword-fill",
  },
];

export default function SectTimeline() {
  return (
    <section className="container-x py-12 md:py-16">
      <div className="mx-auto max-w-2xl text-center">
        <p className="text-xs font-medium tracking-widest text-primary-600">宗门篇脉络</p>
        <h2 className="mt-2 font-heading text-2xl font-bold text-foreground-950 md:text-3xl">宗门篇的三段式推进</h2>
        <p className="mt-3 text-sm leading-relaxed text-foreground-500">
          看懂宗门篇的完整发展脉络，再看后续主线走向会清晰得多。
        </p>
      </div>

      <div className="relative mx-auto mt-12 max-w-3xl">
        <div className="absolute left-5 top-0 h-full w-px bg-gradient-to-b from-primary-300 via-accent-300 to-secondary-300 md:left-1/2"></div>

        <div className="space-y-10">
          {stages.map((s, i) => (
            <div
              key={s.name}
              className={`relative flex flex-col gap-4 pl-14 md:w-1/2 md:pl-0 ${
                i % 2 === 0 ? "md:pr-12 md:text-right" : "md:ml-auto md:pl-12"
              }`}
            >
              <span
                className={`absolute left-5 top-0 flex h-10 w-10 -translate-x-1/2 items-center justify-center rounded-full border-2 border-accent-300 bg-background-50 text-lg text-accent-600 md:left-auto ${
                  i % 2 === 0 ? "md:left-full" : "md:left-0"
                }`}
              >
                <i className={s.icon}></i>
              </span>
              <div
                className={`rounded-xl border border-background-200/70 bg-background-50 p-5 shadow-soft ${
                  i % 2 === 0 ? "md:mr-0" : ""
                }`}
              >
                <span className="text-xs font-medium tracking-widest text-accent-600">{s.step}</span>
                <h3 className="mt-1 font-heading text-lg font-semibold text-foreground-950">{s.name}</h3>
                <p className="mt-2 text-sm leading-relaxed text-foreground-500">{s.desc}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}